import { listStoreLenses } from 'root/src/client/logic/list/lenses'

const { viewListDataLength } = listStoreLenses

export default (state, { moduleId }) => viewListDataLength(moduleId, state)
